import { RequestKind, boolean, number, string } from '@sb/library/base';
import { BalanceSummaryRequestItem, BatchTransactionUpdateItem, DisplayItemCollection, FamilyBalancesRequestItem, FamilyBalancesResultItem, SendTransactionReceiptInputItem, TotalBalanceResultItem, TransactionDeleteOptions, TransactionDisplayItem, TransactionInputItem, TransactionSearchOptions, TransactionSummarySearchOptions, TransactionUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TransactionRoutes {
    export const Add = ApiRoute.Define({
        URL: 'transactions',
        Kind: RequestKind.Post,
        BodyType: TransactionInputItem,
        ResultType: string
    });

    export const Batch = ApiRoute.Define({
        URL: 'transactions',
        Kind: RequestKind.Patch,
        BodyType: BatchTransactionUpdateItem,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: 'search/transactions',
        Kind: RequestKind.Post,
        BodyType: TransactionSearchOptions,
        OrderByType: TransactionDisplayItem,
        RequestedFieldsType: TransactionDisplayItem,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<TransactionDisplayItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (transactionID: string) => `transactions/${transactionID}`,
        Kind: RequestKind.Delete,
        BodyType: TransactionDeleteOptions,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (transactionID: string) => `transactions/${transactionID}`,
        Kind: RequestKind.Get,
        ResultType: TransactionDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'transactions',
        Kind: RequestKind.Get,
        PagingAllowed: true,
        OrderByType: TransactionDisplayItem,
        RequestedFieldsType: TransactionDisplayItem,
        ResultType: DisplayItemCollection<TransactionDisplayItem>
    });

    export const Update = ApiRoute.Define({
        URL: (transactionID: string) => `transactions/${transactionID}`,
        Kind: RequestKind.Put,
        BodyType: TransactionUpdateItem,
        ResultType: string
    });

    export namespace Balance {
        export const Get = ApiRoute.Define({
            URL: 'summary/balance',
            Kind: RequestKind.Post,
            BodyType: BalanceSummaryRequestItem,
            ResultType: number
        });

        export const FamiliesSummary = ApiRoute.Define({
            URL: 'summary/family/balances',
            Kind: RequestKind.Post,
            BodyType: FamilyBalancesRequestItem,
            ResultType: Array<FamilyBalancesResultItem>
        });

        export const GetAllFamilies = ApiRoute.Define({
            URL: 'summary/totalbalance',
            Kind: RequestKind.Post,
            BodyType: BalanceSummaryRequestItem,
            ResultType: TotalBalanceResultItem
        });
    }

    export const GetTransactionSummary = ApiRoute.Define({
        URL: 'summary/transactions/sum',
        Kind: RequestKind.Post,
        BodyType: TransactionSummarySearchOptions,
        ResultType: number
    });

    export const SendReceipt = ApiRoute.Define({
        URL: (transactionID: string) => `transactions/${transactionID}/sendreceipt`,
        Kind: RequestKind.Post,
        BodyType: SendTransactionReceiptInputItem,
        ResultType: boolean
    });
}
